import _ from "lodash";
import RequestError from "./RequestError";
import api from "@/api";

/**
 * @typedef RequestConfig
 * @prop {string} path
 * @prop {string} method
 * @prop {Object} [params]
 * @prop {any} [data]
 */

export default {
  getVmixTokens,
  createVmixToken,
  deleteVmixToken,
  updateVmixToken,
};

// The list belongs to whichever account the session has selected, but the URL
// does not include that account. A browser or CDN cache of this GET therefore
// keeps returning the previous account's token until a full reload bypasses it.
let tokenFetchSeq = 0

function getVmixTokens() {
	return makeRequest({
		path: '/integrations/vmix/token',
		method: 'get',
		params: { _: ++tokenFetchSeq },
		headers: {
			'Cache-Control': 'no-cache',
			Pragma: 'no-cache',
		},
	});
}

/**
 * @param {object} payload
 */
async function createVmixToken(payload) {
	return makeRequest({
		path: '/integrations/vmix/token',
		method: 'post',
    data: payload
	});
}

/**
 * @param {string} id
 * @param {string} name
 */
async function updateVmixToken(id, name) {
	return makeRequest({
		path: `/integrations/vmix/token/${id}`,
		method: 'patch',
    data: {
      name,
    }
	});
}

/**
 * @param {string} id
 */
async function deleteVmixToken(id) {
	return makeRequest({
		path: `/integrations/vmix/token/${id}`,
		method: 'delete',
	});
}


/**
 * @param {RequestConfig|string} reqConfig
 */
async function makeRequest(reqConfig, preventProxy, throwReal) {
  if (typeof reqConfig === "string") {
    reqConfig = {
      path: reqConfig,
    };
  }

  reqConfig.url = reqConfig.path;

  let res;
  try {
    res = await api.request(reqConfig);
  } catch (err) {
    if (throwReal) {
      throw err;
    }
    const edata = _.get(err, "response.data");
    throw new RequestError(edata);
  }

  return res && res.data;
}

